import { deleteAllFormData, getLatestFormData, storeFormData } from '../storage/indexedDB';
import { getImageDimensions, getNormalizedFile } from '../utils/fileUtils';

/**
 * Check if an image is already attached and update UI accordingly
 */
export const checkAttachedImage = async (): Promise<void> => {
  try {
    const storedFormData = await getLatestFormData();
  } catch (error) {
    // Handle error silently
  }
};

/**
 * Handler for removing the attached image
 */
export const removeAttachedImage = async (): Promise<void> => {
  try {
    await deleteAllFormData();
  } catch (error) {
    // Handle error silently
  }
};

/**
 * Handler for image upload button click
 * @param event The click event
 */
export const onClickUploadImage = async (event: MouseEvent): Promise<void> => {
  event.preventDefault(); // Prevent any default form submission behavior

  // Check if we need to remove existing image
  try {
    const storedFormData = await getLatestFormData();
    if (storedFormData) {
      return removeAttachedImage();
    }
  } catch (error) {
    // Silent error handling - proceed with upload
  }
};

/**
 * Handler for file input change event
 * @param event The change event
 */
export const onFileInputChange = async (event: Event): Promise<void> => {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0];

  if (file) {
    // Convert file to base64 for processing
    const reader = new FileReader();
    const image = new Image();

    reader.onload = async (e) => {
      const base64Data = e.target?.result;
      image.src = reader.result as string;
      const fileSize = file.size;

      try {
        const dimensions = await getImageDimensions(base64Data as string);

        const finalFile = {
          attachment: file,
          file_name: new Date().getTime().toString(),
          file_width: dimensions.width.toString(),
          file_height: dimensions.height.toString(),
          file_type: 'image',
          file_size: fileSize.toString(),
          tag_list: '',
        };

        const formData = new FormData();
        formData.append('attachment', finalFile.attachment);
        formData.append('file_name', finalFile.file_name);
        formData.append('file_width', finalFile.file_width.toString());
        formData.append('file_height', finalFile.file_height.toString());
        formData.append('file_size', finalFile.file_size);
        formData.append('file_type', finalFile.file_type);
        formData.append('tag_list', finalFile.tag_list);
        formData.append('media_bin', 'true');

        // Store FormData in IndexedDB
        await storeFormData(formData);
      } catch (error) {
        // Handle error silently to prevent app crashes
      }
    };

    try {
      const normalizedFile = await getNormalizedFile(file);
      reader.readAsDataURL(normalizedFile);
    } catch (error) {
      // Handle error silently to prevent app crashes
    }
  }
};
